import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { BaseError } from '@utils/types/shared/base';
import { RetrySessionResponse } from '@utils/types/admin';
import { ADMIN_SESSIONS_QUERY_KEY } from './use-get-admin-sessions';

/**
 * Hook to retry a single failed/stranded session
 *
 * POST /api/admin/on-prem/sessions/{session_id}/retry
 *
 * Re-queues the session for processing
 */
export const useRetryAdminSession = () => {
  const queryClient = useQueryClient();

  const retrySession = async (sessionId: string) => {
    const response = await Axios.post<RetrySessionResponse>(
      `api/admin/on-prem/sessions/${sessionId}/retry`
    );
    return response.data;
  };

  return useMutation<RetrySessionResponse, AxiosError<BaseError>, string>(
    retrySession,
    {
      onSuccess: () => {
        queryClient.invalidateQueries([ADMIN_SESSIONS_QUERY_KEY]);
      }
    }
  );
};
